import { UPDATE_USER, CURRENT_STATUS } from '../../modules/phoneAuth/actions';
import { LOGOUT } from '../../views/logout';


export default function metadataReducer(state = {}, action) {
  let newState = state;
  const { type, payload } = action;

  switch (type) {
    case UPDATE_USER: {
      newState = { ...newState, user: payload.user };
      break;
    }
    case CURRENT_STATUS: {
      newState = { ...newState, status: payload };
      break;
    }
    case LOGOUT: {
      newState = { ...newState, user: {} };
      break;
    }
    default:
      break;
  }
  return newState;
}